import {h, Component} from 'preact';
import TicketLogic from "../utils/ticket-logic";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../config.jsx";
import User from "../../../services/user"

import * as T from "../desktop-templates/prematch-right-col.jsx";
import AwrabetTicketLoadBet from '../../awrabet/desktop-components/ticket-load-bet.jsx';

export default class TicketLoadBet extends AwrabetTicketLoadBet {
	render() {
		return <div>
			<T.ColumnTitleRow>
				<T.ColumnTitleLabel><Trans>Ricarica Scommessa</Trans></T.ColumnTitleLabel>
			</T.ColumnTitleRow>
			<T.ColumnContent>
				<T.HelperText><Trans>Insert the code to load</Trans></T.HelperText>
				<T.ContentRowFlex>
					<T.InputContainer>
						<input type="text" onInput={e => this.setState({ticketid: e.target.value, error: null})} class="text-inherit bg-transparent w-full  focus:outline-hidden focus:border-custom-orange focus:ring-1 focus:ring-custom-orange" />
					</T.InputContainer>
					<T.SubmitButton onClick={e => this.reloadReservedTicket()} />
				</T.ContentRowFlex>
				{this.state.error && <T.ErrorText>
					{this.state.error == 'login' && <Trans>Please login to load a bet</Trans>}
				</T.ErrorText>}
			</T.ColumnContent>
		</div>;
	}
}
